import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import CompaniesEdit from '@src/features/company/companies/CompaniesEdit';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyEdit() {
  return (
    <CompanyGuard canRoles={[COMPANY_ROLE.ADMIN]}>
      <CompanyDefaultLayout pageName='companies'>
        <CommonHelmet />
        <CompaniesEdit />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyEdit;
